import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";

type Props = {
  id: string;
  name: string;
  type: string;
  label: string;
  value?: string;
  placeholder?: string;
  required?: boolean;
  error?: string | null;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  helpText?: string;
  minLength?: number;
  icon?: string;
};

const AuthFormInput = ({
  id,
  name,
  type,
  label,
  value,
  placeholder,
  required = false,
  error = null,
  onChange,
  helpText,
  icon,
  ...props
}: Props) => {
  return (
    <div className="flex flex-column">
      <label htmlFor={id} className="mb-1 text-sm">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <span
        className={classNames(" w-full", {
          "p-input-icon-left": icon,
        })}
      >
        <i className={icon}></i>
        <InputText
          {...props}
          id={id}
          name={name}
          type={type}
          className={classNames(
            "w-full bg-white border-none border-noround text-gray-800",
            {
              "p-invalid": !!error,
            }
          )}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required={required}
        />
      </span>
      {helpText && (
        <small className="text-gray-300 text-xs mt-2">{helpText}</small>
      )}
    </div>
  );
};

export default AuthFormInput;
